export default __webpack_public_path__ + "static/media/partes.a2ccee9f.jpg";